import React, { ReactNode } from "react";
import styled from "styled-components";

export interface MenuItem {
  name: string;
  description?: string;
  slug?: string;
  children?: Array<MenuItem>;
  content?: ReactNode;
  noHeader?: boolean;
}

export interface MenuNodeProps {
  node: MenuItem;
  nameFilter?: string;
}

const MenuNode: React.FC<MenuNodeProps> = (props) => {
  const {
    node: { name, description, slug, children },
  } = props;

  const leaf = !children;

  const className = ["name", leaf ? "leaf" : "branch"].join(" ");

  return (
    <StyledComponent>
      {leaf ? (
        <a
          className={className}
          href={"#" + (slug || name)}
          title={description}
        >
          {name}
        </a>
      ) : (
        <div className={className}>{name}</div>
      )}

      <StyledChildren>
        {children &&
          children.map((child, i) => (
            <MenuNode key={i} {...props} node={child} />
          ))}
      </StyledChildren>
    </StyledComponent>
  );
};

const StyledComponent = styled.div`
  a {
    text-decoration: none;
    color: inherit;
  }

  .name {
    display: block;
    padding: 0.4em 0.5em;

    &.leaf {
      &:hover,
      &.active {
        /* background-color: #eee; */
        background-color: #f1b310;
        border-radius: 4px;
      }
    }

    &.branch {
      font-weight: 600;
      margin-top: 1.3rem;
    }
  }
`;

const StyledChildren = styled.div`
  padding-left: 1em;
  &:hover {
  }
`;

export default MenuNode;
